export default "__VITE_ASSET__c14ecf31__"